import React, { useState, useRef, useEffect } from "react";
import editIcon from "../../../assets/images/editIcon02.png";
import saveIcon from "../../../assets/images/Check.svg";
import clearIcon from "../../../assets/images/X.svg";
import starRatingImg from "../../../assets/images/green_star03.png";

const StarRating = ({
  options,
  optionList,
  name,
  id,
  onChangeOption,
  defaultValue,
  customStyle = "",
  isReadOnly = false,
  showEditIcon = false,
  saveEdit,
  required,
  defaultCustomStyle,
  editCustomStyle,
  editSaveCustomStyle,
  onEditClick,
  onCancelEdit,
  label,
  onFieldBlur
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [updatedVal, setUpdatedVal] = useState(defaultValue || "");
  const wrapperRef = useRef(null);
  const selectRef = useRef(null);
  const isOptionUpdate = true;

  const notEditable = isReadOnly && !showEditIcon;

  useEffect(() => {
    setUpdatedVal(defaultValue || "");
  }, [defaultValue]);

  useEffect(() => {
    if (isEditable && selectRef.current) {
      selectRef.current.focus();
    }
  }, [isEditable]);

  const onSelect = (e) => {
    onChangeOption(id, e.target.value, isOptionUpdate);
  };

  const onOptionSelect = (e) => {
    if (showEditIcon) setUpdatedVal(e.target.value);
    onSelect(e);
  };

  const onSaveEdit = async () => {
    if (defaultValue === updatedVal) {
      setIsEditable(false);
    } else {
      const isValueEdited = Boolean(defaultValue);
      saveEdit(id, updatedVal, isValueEdited, name, isOptionUpdate, optionList);
      setIsEditable(false);
    }
    if (onCancelEdit) onCancelEdit();
  };

  const handleCancel = async () => {
    if (onCancelEdit) await onCancelEdit();
    setUpdatedVal(defaultValue);
    setIsEditable(false);
  };

  const handleBlur = (e) => {
    if (onFieldBlur && isEditable) {
      const next = e.relatedTarget;
      const isSaveOrCancel =
        next?.alt === "save edit" ||
        next?.alt === "clear edit" ||
        next?.closest(".save-cancel-wrapper");

      const clickedInsideSaveCancel =
        e.currentTarget.parentElement?.querySelector(".save-cancel-wrapper")?.contains(document.activeElement);

      if (!isSaveOrCancel && !clickedInsideSaveCancel) {
        onFieldBlur();
      }
    }
  };

  const handleEditClick = () => {
    setIsEditable(true);
    if (onEditClick) onEditClick(label, true);
  };

  return (
    <div className={`flex ${showEditIcon ? "justify-between" : "justify-start"}`}>
      <div
        className="border border-saffronMango px-2.5 py-1 flex rounded w-fit items-center"
        ref={wrapperRef}
        tabIndex="0"
        onBlur={handleBlur}
      >
        <img
          src={starRatingImg}
          alt="star rating"
          className="w-3 h-3 cursor-pointer mt-[3px] mr-1"
        />

        {showEditIcon && !isEditable && defaultValue && (
          <p
            className={`text-sm text-left text-black font-medium capitalize ${
              defaultCustomStyle ? "mt-0" : "mt-1"
            }`}
          >
            {defaultValue}
          </p>
        )}

        {(!showEditIcon || (showEditIcon && isEditable) || !defaultValue) && (
          <select
            ref={selectRef}
            className={`w-4/5 border-none outline-none text-sm text-left text-grayNobel placeholder-grayNobel disabled:text-grayNobel focus:text-tileGray font-normal h-5 ${
              defaultCustomStyle ? "mt-0" : "mt-1"
            } ${customStyle} appearance-none`}
            name={name}
            id={id}
            value={updatedVal}
            required={required}
            disabled={notEditable || (showEditIcon && !isEditable)}
            onChange={onOptionSelect}
          >
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
      </div>

      {!isEditable && showEditIcon && (
        <button
          type="button"
          aria-label="edit"
          data-action="edit"
          className={`ml-ten mt-[7px] ${editCustomStyle}`}
          onClick={handleEditClick}
        >
          <img src={editIcon} alt="edit" className="h-4 w-4 cursor-pointer" />
        </button>
      )}

      {isEditable && (
        <div className={`grid -mt-4 ml-2 gap-2 save-cancel-wrapper ${editSaveCustomStyle}`}>
          <button
            type="button"
            aria-label="save edit"
            data-action="save"
            onClick={onSaveEdit}
            className="w-4 h-4 cursor-pointer"
          >
            <img src={saveIcon} alt="save edit" />
          </button>

          <button
            type="button"
            aria-label="clear edit"
            data-action="cancel"
            onClick={handleCancel}
            className="w-4 h-4 cursor-pointer"
          >
            <img src={clearIcon} alt="clear edit" />
          </button>
        </div>
      )}
    </div>
  );
};

export default StarRating;
